import { FC } from 'react';
import { useTrans } from 'base/utils/i18n';
import { IICartGroupBar } from 'mod/cart/interface';
import { Countdown, RenderParamType } from '@base/lib/Countdown';
import { CartType } from '@base/cart/useCart';

type ICartGroupHeaderTipProps = {
    className?: string;
    data: IICartGroupBar;
    loadCart: CartType['loadCart'];
};

function getCountdownText(o: RenderParamType) {
    if (Number(o.day) > 0) {
        return `${o.day} ${o.dayText}`
    }
    if (Number(o.hour) > 0) {
        return `${o.hour} ${o.hourText}`
    }
    if (Number(o.minute) > 0) {
        return `${o.minute} ${o.minuteText}`
    }
    return `${o.second} ${o.secondText}`
}

export const CartGroupHeaderTip: FC<ICartGroupHeaderTipProps> = props => {
    const { className, data, loadCart } = props;
    const { tips, endTimestamp } = data;
    const { t } = useTrans();

    if (!tips) {
        return null;
    }

    if (tips.includes('{{time}}') && endTimestamp) {
        return (
            <Countdown
                className={className}
                isShowDay={true}
                endTime={endTimestamp}
                dayText={[t('web_common_day_lower'), t('web_common_days_lower')]}
                hourText={[t('web_common_hour_lower'), t('web_common_hours_lower')]}
                minuteText={[t('web_common_minute_lower'), t('web_common_minutes_lower')]}
                secondText={[t('web_common_second_lower'), t('web_common_seconds_lower')]}
                render={(o) => {
                    const conutdownText = getCountdownText(o);
                    return tips.replace('{{time}}', `<span class="g-time">${conutdownText}</span>`);
                }}
                endRender={() => {
                    loadCart({ loadingType: 'whole' });
                    return ''
                }}
            />
        )
    }

    return (
        <div className={className}>
            {tips}
        </div>
    )
};
